import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { jobInputItemsClearStore } from 'reducers/jobInputItemsAdmin/reducer'
import JobInputItemList from './JobInputItemList'

function JobInputItems(props) {
  const { jobInputItemsClearStore } = props

  useEffect(
    () => () => {
      jobInputItemsClearStore()
    },
    [],
  )

  return (
    <div className="content">
      <JobInputItemList {...props} />
    </div>
  )
}

JobInputItems.propTypes = {
  jobInputItemsClearStore: PropTypes.func.isRequired,
}

export default connect(null, {
  jobInputItemsClearStore,
})(JobInputItems)
